/**
 * Created by idea on 20/03/2017.
 */
import { Injectable } from '@angular/core';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';

@Injectable()
export class ApiService {
    private header: Headers;
    private endPoint: string;

    constructor(private http: Http, private router: Router) {
        let contentHeaders = new Headers();
        this.header = contentHeaders;
        this.header.set('Access-Control-Allow-Origin', '*');

    }

    public setHeader(key: string, value: string): ApiService {
        this.header.set(key, value);
        return this;
    }

    public setEndPoint(s: string) {
        this.endPoint = s;
    }

    get(url: string, options?: any): Observable<any> {
        let params = new URLSearchParams();
        if (typeof options === 'object') {
            for (var i in options) {
                params.set(i, options[i]);
            }
        }
        if (localStorage.getItem('Access-Token')) {
            this.header.set('x-token', localStorage.getItem('Access-Token'));
        }
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.get(environment.api + url, { headers: this.header, search: params })
            .map((res: any) => {
                return this.check(res);
            })
            .catch((error: any) => {
                throw this.checkErr(error)
            });
    }

    post(url: string, body?: any): Observable<any> {
        if (localStorage.getItem('Access-Token')) {
            this.header.set('x-token', localStorage.getItem('Access-Token'));
        }
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.post(environment.api + url, body, { headers: this.header })
            .map((res: Response) => {
                return this.check(res);
            })
            .catch((error: any) => {
                throw this.checkErr(error);
            });
    }


    put(url: string, body?: any): Observable<any> {
        if (localStorage.getItem('Access-Token')) {
            this.header.set('x-token', localStorage.getItem('Access-Token'));
        }
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.put(environment.api + url, body, { headers: this.header })
            .map((res: Response) => {
                return this.check(res);
            })
            .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
    }

    delete(url: string, options?: any): Observable<any> {
        if (localStorage.getItem('Access-Token')) {
            this.header.set('x-token', localStorage.getItem('Access-Token'));
        }
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.delete(environment.api + url, { headers: this.header, search: options })
            .map((res: Response) => {
                return this.check(res);
            })
            .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
    }

    all(data?: {}) {
        return this.get(this.endPoint, data);
    }

    find(id, data?: {}) {
        return this.get(this.endPoint + "/" + id, data);
    }

    add(data: {}) {
        return this.post(this.endPoint, data);
    }

    update(id, data: {}) {
        return this.put(this.endPoint + "/" + id, data);
    }

    remove(id, data?: {}) {
        return this.delete(this.endPoint + "/" + id, data);
    }

    /**
     * 2017/07/07: Nguyen Hung
     * Upgraded : addition statusCode 201,204
     * @param res json
     */

    check(res) {
        var response = res.json();
        let status;
        if (response.hasOwnProperty('statusCode')) {
            status = response.statusCode;
        }
        if (response.hasOwnProperty('status')) {
            status = response.status;
        }

        if (status == 200 || status == 201 || status == 200) {
            if (response.data)
                return response.data;
            else
                return true;
        } else if (status == 400) {
            throw res;
        } else if (status == 401 || status == 402) {
            throw res;
        } else if (status == 403) {
            localStorage.removeItem('Access-Token');
            localStorage.removeItem('Access-Token-Icheck');
            this.router.navigate(['/login']);
        } else if (status == 406) {
            this.router.navigate(['/permission/error']);
            throw res;
        } else if (status == 204) {
            return true;
        } else {
            throw res;
        }
    }

    checkErr(err) {
        var errorRes = err.json();

        let status;
        if (errorRes.hasOwnProperty('statusCode')) {
            status = errorRes.statusCode;
        }
        if (errorRes.hasOwnProperty('status')) {
            status = errorRes.status;
        }

        if (status == 200 || status == 201) {
            if (errorRes.data)
                return errorRes.data;
            else
                return true;
        } else if (status == 400) {
            throw errorRes;
        } else if (status == 401 || status == 402) {
            throw errorRes;
        } else if (status == 403) {
            localStorage.removeItem('Access-Token');
            localStorage.removeItem('Access-Token-Icheck');
            this.router.navigate(['/login']);
        } else if (status == 404) {
            throw { message: 'Không có dữ liệu.' };
        } else if (status == 406) {
            this.router.navigate(['/permission/error']);
            throw errorRes;
        } else if (status == 204) {
            return true;
        } else {
            throw { message: 'Có lỗi xảy trong quá trình lấy thông tin. Vui lòng thử lại sau.' };
        }
    }
}


// WEBPACK FOOTER //
// /app/src/app/common/services/Api.service.ts